<template>
    <b-card>
        <!-- filter  -->
        <div v-if="loading" class="text-center mt-4">
            <b-spinner label="Loading..."></b-spinner>
        </div>
        <div class="col-12 mt-16">
            <div>
                <b-row class="align-items-center">
                    <b-col lg="6" class="my-1">
                        <b-form-group label="" label-for="filter-input" label-cols-sm="1" label-align-sm="right"
                            label-size="sm" class="mb-0">
                            <b-input-group size="sm">
                                <b-form-input id="filter-input" v-model="filter" type="search"
                                    placeholder="Type to Search"></b-form-input>
                                <b-input-group-append>
                                    <b-button @click="applyFilter" :disabled="!filter"
                                        variant="primary">Apply</b-button>
                                <b-button :disabled="!filter" @click="clearFilter">Clear</b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                
                        <b-col lg="4" class="my-1 d-flex justify-content-end">
                        <b-button  v-b-tooltip.hover title="Delete All Notifications" @click="deleteAllNotification" variant="primary" class="mb-8 mr-8">
                            Clear All Notification
                        </b-button>
                        </b-col>

                        <b-modal v-model="deleteAllNotifications" title="Delete Confirmation">
                            <p>Are you sure you want to delete all notifications?</p>
                            <template #modal-footer>
                                <b-button variant="primary" @click="deleteItemNotification">Delete</b-button>
                                <b-button variant="primary" @click="deleteAllNotifications = false">Cancel</b-button>
                            </template>
                        </b-modal>
                       
    

                    <b-col lg="2" class="my-1 d-flex justify-content-end">
                        <b-button @click="exportAllDataToCSV" variant="primary" class="mb-8 mr-8">Export</b-button>
                    </b-col>
                </b-row>
            </div>
        </div>
        <!-- filter end -->
        <b-row>
            <div class="col-12 mt-16">
                <b-skeleton-table
                    v-if="loading"
                    :rows="perPage"
                    :columns="fields.length"
                    animation="wave"
                    bordered
                    class="mb-3"
                    />
                <b-table v-else id="dataTable" :items="users" :busy.sync="loading" :fields="fields" :current-page="currentPage"
                :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" show-empty responsive striped hover  class="custom-zebra">

                <template #cell(vehicle_vin)="row">
                <template v-if="row.item.vehicle?.vin">
                    <b-button v-b-tooltip.hover title="Redirect to the Vehicle page for searching the vehicle through this VIN"
                    variant="link"
                    @click="navigateToVehicle(row.item.vehicle.vin)"
                    class="p-0"
                    >
                    {{ row.item.vehicle.vin }}
                    </b-button>
                </template>
                <template v-else>
                <span class="text-muted">N/A</span>
                </template>
                </template>
                      <!-- Title  code here  -->
                   <template #cell(title)="row">
                        {{ row.item.title ||'N/A' }}
                    </template>
                    <template #cell(vehicle.registration_number)="row">
                        <template v-if="row.item.vehicle?.registration_number">
                            {{ row.item.vehicle.registration_number }}
                        </template>
                        <template v-else>
                            <span class="text-muted">N/A</span>
                        </template>
                    </template>

                    <template #cell(actions)="row">
                 
                        <!-- delete -->
                        <b-button v-b-tooltip.hover title="Delete Notification" @click="showDeleteConfirmation(row.item.id)" variant="link" class="p-0">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor"
                                style="color: red; margin-left: 6px; margin-bottom: 10px" class="bi bi-eye"
                                viewBox="0 0 16 16">
                                <!-- ... your SVG path ... -->
                                <path
                                    d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z" />
                            </svg>
                        </b-button>
                        <b-modal v-model="showDeleteConfirmations" title="Delete Confirmation">
                            <p>Are you sure you want to delete this item?</p>
                            <template #modal-footer>
                                <b-button variant="primary" @click="deleteItem(itemIdToDelete)">Delete</b-button>
                                <b-button variant="primary" @click="showDeleteConfirmations = false">Cancel</b-button>

                            </template>
                        </b-modal>
                        <!-- end delete -->
                    </template>
                                  <!-- image  show code here  -->
                      
                    <template #cell(image)="row">
                    <div>
                        <template v-if="row.item.image">
                        <img :src="'https://wossdb.wossautoid.com/' + row.item.image" alt="Picture" width="100" height="100"    />
                        </template>
                        <template v-else>
                        N/A
                        </template>
                    </div>
                    </template>


                    <b-form-group label="Filter" label-for="filter-input" label-cols-sm="3" label-align-sm="right"
                        label-size="sm" class="mb-0">
                        <b-input-group size="sm">
                            <b-form-input id="filter-input" v-model="filter" type="search"
                                placeholder="Type to Search"></b-form-input>

                            <b-input-group-append>
                                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-table>
                <div class="mx-8 d-flex justify-content-end">
                    <b-pagination v-model="currentPage" :total-rows="total" :per-page="perPage"
                    aria-controls="dataTable" @change="pageChanged"></b-pagination>
                </div>
                <b-row class="mt-16 align-items-center justify-content-end">

                    <b-row>

                    </b-row>
                </b-row>
            </div>
        </b-row>
    </b-card>
</template>

<script>
import {
    BRow,
    BCol,
    BCard,
    BButton,
    BTable,
    BFormGroup,
    BInputGroup,
    BFormInput,
    BFormSelect,
    BPagination,
    BInputGroupAppend,
    BSpinner,
    BSkeleton,
    BSkeletonTable,
} 
from "bootstrap-vue";
// import axios from "axios";
import axios from "../../../axios";
import Papa from "papaparse";
import {
  initNotificationRealtime,
  applyListSync,
  notificationBus,
} from "../../../utils/notificationRealtime";

export default {
    data() {
        return {
            perPage: 10,
            currentPage: 1,
            sortBy: "",
            sortDesc: false,
            lastPage: 0,
            firstPageUrl: null,
            lastPageUrl: null,
            nextPageUrl: null,
            prevPageUrl: null,
            isLoading: false,
            selectedCardOption: "",
            rowToUpdate: null,
            modalVisible: false,
            modalVisibleDoument: false,
            users: [],
            fields: [
                { key: "id", sortable: true },
                { key: "title", sortable: true },
                { key: "vehicle_vin",label:"Vehicle Identification Number", sortable: true },
                { key: "vehicle.registration_number",label:"Vehicle Registration Number", sortable: true },
                { key: "image", sortable: true },
                { key: "actions", label: "Actions" },
            ],
            image: "",
            filter: "",
            total: 0, 
            showDeleteConfirmations: false,
            itemIdToDelete: null,
            loading: false,
            deleteAllNotifications: false,

        };

    },

    components: {
        BRow,
        BCol,
        BCard,
        BButton,
        BTable,
        BFormGroup,
        BInputGroup,
        BFormInput,
        BFormSelect,
        BPagination,
        BInputGroupAppend,
        BSpinner,
        BSkeleton,
        BSkeletonTable,

    },
    computed: {
        sortOptions() {
            return this.fields
                .filter((f) => f.sortable)
                .map((f) => {
                    return { text: f.label, value: f.key };
                });
        },
        rows() {
            return this.users.length;
        },
    },
    mounted() {
        initNotificationRealtime("super_admin");
        notificationBus.$on("sync", this.onNotificationListSync);
        this.fetchData();
    },
    beforeDestroy() {
        notificationBus.$off("sync", this.onNotificationListSync);
    },
    methods: {
        onNotificationListSync({ payload, userType }) {
            if (userType !== "super_admin") {
                return;
            }

            const synced = applyListSync(this.users, this.total, payload, userType);
            this.users = synced.users;
            this.total = synced.total;

            if (synced.shouldRefetch) {
                this.fetchData();
            }
        },

    navigateToVehicle(vin) {
  
    this.$router.push({ name: 'ListVehicle', params: { vin } });
    },
        clearFilter() {
            this.filter = '';     
            this.currentPage = 1;   
            this.fetchData();       
        },
        async fetchData() {
            this.loading = true;
            let apiUrl = "getUserNotifications";
            try {
                const response = await axios.post(apiUrl, {
                         page: this.currentPage, per_page: this.perPage 
                });

                this.users = response.data.data;
                this.total = response.data.total;
                this.currentPage = response.data.current_page;
                this.perPage = response.data.per_page;
                this.lastPage = response.data.last_page;
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                this.loading = false;
            }
        },
        applyFilter() {
            // Handle applying the filter
            this.loading = true;
            let apiUrl = "getUserNotifications"; 
            axios
                .post(apiUrl, {
                    params: {
                        search: this.filter,
                    },
                })
                .then((response) => {
                    this.users = response.data.data;
                    this.total = response.data.total;
                    this.currentPage = response.data.current_page;
                })
                .catch((error) => {
                    console.error("Error applying filter:", error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        pageChanged(newPage) {
            this.currentPage = newPage;
            this.fetchData();
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        codeClick() {
            this.codeActive = !this.codeActive;
        },
        exportAllDataToCSV() {
            this.fetchAllParents((allParents) => {
                const csv = Papa.unparse(allParents);
                const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.setAttribute("download", "exported_data.csv");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            });
        },
        fetchAllParents(callback) {
            axios
                .get("brandforExport", { params: { per_page: this.totalRows } })
                .then((response) => {
                    callback(response.data.data);
                })
                .catch((error) => {
                    console.error("Error fetching all Data:", error);
                });
        },

      
        ///  delete
        showDeleteConfirmation(itemId) {
            this.itemIdToDelete = itemId;
            this.showDeleteConfirmations = true;
        },
        deleteItem(itemId) {

            this.itemIdToDelete = itemId; // Set the item ID to be deleted
            axios
                .delete(`deleteNotificationAdmin/${itemId}`)
                .then((response) => {
                    this.showDeleteConfirmations = false;
                    this.fetchData(); // Refresh the data after deletion
                })
                .catch((error) => {
                    // Handle error
                    console.error("Error deleting item:", error);
                });
        },
        // Delete  All  Notification  code  here 
        deleteAllNotification() {
        this.deleteAllNotifications = true; 
        },
            deleteItemNotification() {
        axios
            .delete(`Alldestroy `) 
            .then((response) => {
                this.deleteAllNotifications = false; 
                this.fetchData();
            })
            .catch((error) => {
                console.error("Error deleting notifications:", error); 
            });
            },
        formatDate(dateString) {
            const date = new Date(dateString);
            return date.toLocaleDateString();

        },
    },
};
</script>
  <style>
  /* Zebra striping */
  .custom-zebra tbody tr:nth-of-type(odd) {
    background-color: #f0f2f5; /* darker than default */
  }

  /* Hover effect */
  .custom-zebra tbody tr:hover {
    background-color: #e0e4ea !important; /* slightly darker hover */
  }
  </style>